
<app-search-filters class="app-filters" [class.app-mobile-hidden]="searchService.activeMobilePanel != 'filters'"></app-search-filters>

<div class="app-search-wrapper">
  <app-search-toolbar></app-search-toolbar>
  <app-search-results *ngIf="searchService.contentType == 'grid'"></app-search-results>
  <app-map-browse *ngIf="searchService.contentType == 'map'"></app-map-browse>
</div>